import React from 'react';
import classNames from 'classnames';
import {useTranslations} from '../../context/TranslationContext';
import './RadioField.less';

const RadioField = ({
    label,
    checked,
    isChecked,
    onChange,
    id,
    radioId,
    name,
    value,
    disabled = false,
    className,
    inputProps = {},
    ref,
    helperText,
    card = false,
    vertical = false,
}) => {
    const { t } = useTranslations();
    const autoId = React.useId();
    const inputId = id || radioId || autoId;
    const checkedState = checked !== undefined ? checked : isChecked;
    const helperId = helperText ? `${inputId}-helper` : undefined;

    const setControlRef = (node) => {
        if (typeof ref === 'function') {
            ref(node);
        } else if (ref) {
            ref.current = node;
        }
    };

    const row = (
        <div className={classNames('radio-row', className, { disabled, 'has-helper-text': helperText, vertical })}>
            <label htmlFor={inputId}>
                <input
                    {...inputProps}
                    ref={setControlRef}
                    type="radio"
                    id={inputId}
                    name={name}
                    value={value}
                    checked={checkedState}
                    onChange={onChange}
                    disabled={disabled}
                    aria-describedby={helperId}
                />
                {t(label)}
            </label>
            {helperText && <div className="helper-text" id={helperId}>{t(helperText)}</div>}
        </div>
    );

    if (!card) {
        return row;
    }
    return <div className={classNames('radio-card', { checked: checkedState, disabled })}>{row}</div>;
};

export default RadioField;
